import React, { Component } from "react";
import { Input, DatePicker } from "antd";
import moment from "moment";

import { Dropdown } from "../../../../components/common/dropdown";
import { apiJourney } from "../../../../api/api-journey";
import { emitter } from "../../../../common/utils/emitter";
import { LockingEdit } from "../locking-edit/locking-edit";

const { RangePicker } = DatePicker;

const CONTRACT_STATUS = [
  { id: -1, code: "ALL", name: "Tất cả" },
  { id: 2, code: "ASSIGNED_CAR", name: "Đã điều xe" },
  { id: 3, code: "IN_PROGRESS", name: "Đang diễn ra" },
  { id: 4, code: "FINISHED", name: "Đã hoàn thành" },
  { id: 5, code: "CANCELED", name: "Đã huỷ" },
  { id: 6, code: "CAR_LOAN", name: "Đang cho mượn xe" },
  { id: 7, code: "DRIVER_LOAN", name: "Đang cho mượn tài" },
  { id: 8, code: "CAR_DRIVER_LOAN", name: "Đang cho mượn xe và tài" },
];

// const CONTRACT_TYPE = [
//     { id: -1, code: 'ALL', name: 'Tất cả' },
//     { id: 1, code: 1, name: 'Có lái' },
//     { id: 2, code: 2, name: 'Không lái' }
// ]
export class JourneySearchBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      car_type: "",
      number_plate: "",
      driver: "",
      contract: "",
      customer: "",
      status: "",
      contract_type: "",
      resource: "",
      branchList: [],
      contractTypeList: [],
      from_datetime_gte: "",
      from_datetime_lte: "",
      checkSearch: false,
      diaries_lock: 0,
    };
    //this.branchs = [];
  }

  componentWillReceiveProps(newProps) {
    if (newProps.has_driver !== this.props.has_driver) {
      this.dropdown.setState({
        title: "Trạng thái",
        titleColor: "colorTitleFirst",
      });
      this.setState({ status: null });
    }
  }

  async componentDidMount() {
    try {
      const getOptions = await apiJourney.getFilterOption();
      if (getOptions.status == "success") {
        this.dataOptions = getOptions.data;
        this.setOptionState();
      } else {
        emitter.emit("FETCH_LOADING", false);
      }
    } catch (error) {
      emitter.emit("FETCH_LOADING", false);
    }
  }

  setOptionState = () => {
    if (!this.dataOptions) {
      return;
    }
    const branch = this.dataOptions.branches.map((item) => {
      return {
        ...item,
        name: item.code,
      };
    });
    const contract_type = this.dataOptions.contract_types.map((item) => {
      return {
        ...item,
        code: item.id,
      };
    });

    branch.unshift({ id: -1, name: "Tất cả" });
    contract_type.unshift({ id: -1, name: "Tất cả" });
    this.setState({
      branchList: branch,
      contractTypeList: contract_type,
      checkSearch: false,
    });

    if (this.lockingEdit) {
      this.lockingEdit.setState({
        lockTime: this.dataOptions.diaries_lock.lock_time,
      });
    }

    this.props.updateLockTime(this.dataOptions.diaries_lock.lock_time);
  };

  onChangeText = (feild, value) => {
    this.setState({ [feild]: value, checkSearch: false });
  };

  search = (event) => {
    if (event.keyCode === 13) {
      this.submitSearch();
      event.preventDefault();
    }
  };

  submitSearch = async () => {
    await this.setState({
      checkSearch: true,
    });
    this.props.search(1);
  };

  setStatus = (value) => {
    if (value.id == -1) {
      this.setState({ status: null, checkSearch: false });
    } else {
      this.setState({ status: value.id, checkSearch: false });
    }
  };

  setBranch = (value) => {
    if (value.id == -1) {
      this.setState({ branch: null, checkSearch: false });
    } else {
      this.setState({ branch: value.code, checkSearch: false });
    }
  };

  setContractType = (value) => {
    if (value.id == -1) {
      this.setState({ contract_type: null, checkSearch: false });
    } else {
      this.setState({ contract_type: value.code, checkSearch: false });
    }
  };

  from_datetime_gte = (date, dateString) => {
    const unixNew = moment(dateString, "DD/MM/YYYY").unix();
    this.setState({
      from_datetime_gte: unixNew * 1000,
      checkSearch: false,
    });
  };

  from_datetime_lte = (date, dateString) => {
    const unixNew = moment(dateString, "DD/MM/YYYY").unix();
    this.setState({
      from_datetime_lte: unixNew * 1000,
      checkSearch: false,
    });
  };

  render() {
    const {
      car_type,
      driver,
      customer,
      number_plate,
      contract,
      branchList,
      contractTypeList,
    } = this.state;

    let contractStatus = CONTRACT_STATUS;
    return (
      <>
        {!this.props.hiddenLock && (
          <LockingEdit
            ref={(ref) => (this.lockingEdit = ref)}
            updateLockTime={this.props.updateLockTime}
          />
        )}
        <div className="search-bar">
          <div className="search-journey-container">
            <div className="search-contract">
              <Dropdown
                ref={(ref) => (this.dropdown = ref)}
                select={(value) => this.setBranch(value)}
                className="input"
                menu={branchList}
                title="Chi nhánh quản lý xe"
              />
              <DatePicker
                // inputReadOnly
                dropdownClassName="date-picker-dropdown-bottom"
                getPopupContainer={(node) => {
                  if (node) {
                    return node.parentNode;
                  }
                  return document.body;
                }}
                className="input"
                onChange={this.from_datetime_gte}
                placeholder="Bắt đầu từ"
                format="DD/MM/YYYY"
              />
              <DatePicker
                // inputReadOnly
                dropdownClassName="date-picker-dropdown-bottom"
                getPopupContainer={(node) => {
                  if (node) {
                    return node.parentNode;
                  }
                  return document.body;
                }}
                className="input"
                onChange={this.from_datetime_lte}
                placeholder="Đến ngày"
                format="DD/MM/YYYY"
              />
              <Input
                onKeyDown={this.search}
                onChange={(param) =>
                  this.onChangeText("car_type", param.target.value)
                }
                value={car_type}
                placeholder="Loại xe"
                className="input"
              />
            </div>
            <div className="search-contract">
              <Input
                onKeyDown={this.search}
                onChange={(param) =>
                  this.onChangeText("number_plate", param.target.value)
                }
                value={number_plate}
                placeholder="Biển KS"
                className="input"
              />
              <Input
                onKeyDown={this.search}
                onChange={(param) =>
                  this.onChangeText("driver", param.target.value)
                }
                value={driver}
                placeholder="Tài xế"
                className="input"
              />
              <Input
                onKeyDown={this.search}
                onChange={(param) =>
                  this.onChangeText("contract", param.target.value)
                }
                value={contract}
                placeholder="Hợp đồng"
                className="input"
              />
              <Input
                onKeyDown={this.search}
                onChange={(param) =>
                  this.onChangeText("customer", param.target.value)
                }
                value={customer}
                placeholder="Khách hàng"
                className="input"
              />
            </div>
            <div className="search-contract">
              <Dropdown
                select={(value) => this.setContractType(value)}
                className="input"
                menu={contractTypeList}
                title="Loại hợp đồng"
              />
              <Dropdown
                select={(value) => this.setStatus(value)}
                className="input"
                menu={contractStatus}
                title="Trạng thái"
              />
              <div style={{ width: "24%" }}></div>
              <div style={{ width: "24%" }}></div>
            </div>
          </div>
          <div onClick={this.submitSearch} className="btn-success">
            <img
              alt=""
              onClick={this.submitSearch}
              style={{
                objectFit: "contain",
                cursor: "pointer",
                marginRight: 5,
              }}
              width={16}
              src={require("../../../../assets/icons/search-solid-white.png")}
            />
            Search
          </div>
        </div>
      </>
    );
  }
}
